// Ported from dev-scrips-pm-react services/scheduling/use-book-appointment.ts (PROD-1190 calendar port)
import { useMutation } from '@tanstack/react-query';
import { post } from '@/shared/api/api-client';
import type { CreateAppointmentRequest } from '@/types/scheduling-api';

interface BookResponse {
  id: string;
}

export function useBookAppointment() {
  return useMutation({
    mutationFn: (request: CreateAppointmentRequest) =>
      // Scope the PracticeId header to the practice being BOOKED INTO (request.practiceId), not the
      // login default — Flutter sends the booking practice here (PROD-14xx). Falls back to the login
      // practice when the body carries none.
      post<BookResponse>('/api/Appointment/Book', request, {
        practiceId: request.practiceId || undefined,
      }),
  });
}
